module.exports = __webpack_public_path__ + "img/xctg.1d2c80ab.png";